<template>
  <section class="banner">
    <div class="banner-slider">
      <div class="slides">
        <div class="container">
          <div class="image-hold">
            <img
              src="@/../public/img/img01.jpg"
              height="565"
              width="963"
              alt="image description">
          </div>
          <div class="banner-content">
            <h1 class="title-head">Die <span class="title-bold">automatisierte</span> Stundenaufzeichnung.</h1>
            <div class="text">
              <p>Unsere künstliche Intelligenz übernimmt die automatische Hochrechnung der Arbeitsstunden – <span class="title-bold">einfach, immer aktuell &amp; rückwirkend.</span></p>
            </div>
            <a
              class="btn btn-primary"
              href="/registration">Kostenfrei testen</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeSlider'
}
</script>
